<template>
  <div class="stats-builder-extra">
    <Transition name="fade-transform">
      <div v-if="hasSecondaryType" class="fade-transform-item">
        <InputWithLabel :label="$t('APP.STATS_BUILDER.CHART_TYPE')">
          <div class="stats-builder-extra__item">
            <ElCascader
              class="stats-builder-extra__item-cascader"
              :value="value"
              :options="options"
              @input="emitChartType"
            />
            <ElButton
              class="stats-builder-extra__item-delete"
              type="danger"
              icon="el-icon-delete"
              size="small"
              @click="hideSecondaryType"
            />
          </div>
        </InputWithLabel>
      </div>
    </Transition>
    <ElCollapseTransition>
      <div v-show="!hasSecondaryType" class="row">
        <div class="column">
          <ElButton type="text" icon="el-icon-plus" @click="showSecondaryType">
            {{ $t('APP.STATS_BUILDER.ADD_CHART') }}
          </ElButton>
        </div>
      </div>
    </ElCollapseTransition>
  </div>
</template>

<script>
import InputWithLabel from '@@/common/InputWithLabel';

export default {
  name: 'StatsBuilderExtra',
  components: {
    InputWithLabel,
  },
  props: {
    options: {
      required: true,
      type: Array,
    },
    value: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      hasSecondaryType: false,
    };
  },
  methods: {
    showSecondaryType() {
      this.hasSecondaryType = true;
    },
    hideSecondaryType() {
      this.hasSecondaryType = false;

      this.emitChartType([]);
    },
    emitChartType(type) {
      this.$emit('input', type);
    },
  },
};
</script>

<style lang="scss">
.stats-builder-extra {
  margin-top: $global-margin;

  &__item {
    display: flex;
    align-items: center;

    &-cascader {
      flex: 1;
    }

    &-delete {
      margin-right: $global-margin;
    }
  }
}
</style>
